<og-floating-labels></og-floating-labels>

<fuse-loading-bar></fuse-loading-bar>
<div *hasPermission></div>
<fuse-vertical-navigation
  class="dark og-platform-navigation print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall"
>
  <!-- Permanent product branding stays above the scrolling navigation. -->
  <div fuseVerticalNavigationHeader class="og-sidebar-brand">
    <button
      type="button"
      class="og-sidebar-brand-link"
      (click)="home()"
      aria-label="Optimum Grading home"
    >
      <img src="assets/images/logo/logo-white.png" alt="" />
      <span class="font-heading og-sidebar-product-name">
        <span class="og-sidebar-product-optimum">OPTIMUM</span>
        <span class="og-sidebar-product-grading">GRADING</span>
      </span>
    </button>
  </div>

  <ng-container fuseVerticalNavigationContentHeader>
    <div class="og-sidebar-team" *ngIf="userData$ | async as userData">
      <div class="og-sidebar-team-logo">
        <img
          *ngIf="userData.club?.logo; else teamLogoFallback"
          [src]="userData.club.logo"
          [alt]="(userData.club?.name || 'Team') + ' logo'"
        />
        <ng-template #teamLogoFallback>
          <mat-icon svgIcon="heroicons_outline:user-group" aria-label="Team"></mat-icon>
        </ng-template>
      </div>
      <div class="og-sidebar-club-name">{{ userData.club?.name }}</div>
      <div class="og-sidebar-coach-email">{{ userData.email }}</div>
    </div>
    <div class="og-sidebar-season">
      <og-select-season [showNested]="true" fieldVariation="fuse-mat-dense"></og-select-season>
    </div>
  </ng-container>
</fuse-vertical-navigation>

<div class="flex flex-col flex-auto w-full min-w-0">
  <div
    class="og-platform-topbar fixed w-full flex flex-0 items-center h-16 px-[1.5rem] md:px-6 z-49 print:hidden"
    [ngStyle]="{
      'max-width': !isScreenSmall && isSideMenuClosed ? 'calc(100% - 256px)' : null,
    }"
  >
    <button
      mat-icon-button
      class="og-topbar-nav-button"
      aria-label="Toggle sidebar"
      (click)="toggleNavigation('mainNavigation')"
    >
      <mat-icon *ngIf="isSideMenuClosed" svgIcon="heroicons_solid:chevron-double-left"></mat-icon>
      <mat-icon *ngIf="!isSideMenuClosed" svgIcon="heroicons_solid:chevron-double-right"></mat-icon>
    </button>

    <button mat-icon-button class="og-topbar-nav-button" aria-label="Home" (click)="home()">
      <mat-icon svgIcon="feather:home"></mat-icon>
    </button>

    <og-select-sob *ngIf="!isMobileScreen"></og-select-sob>

    <div class="flex items-center ml-auto space-x-0.5 sm:space-x-2">
      <button
        mat-fab
        extended
        class="mr-[1rem] support-button"
        [routerLink]="['/help-center']"
        queryParamsHandling="preserve"
      >
        Help Center
        <i class="ph ph-question" aria-hidden="true"></i>
      </button>

      <user [showAvatar]="true"></user>
    </div>
  </div>

  <div class="flex flex-col flex-auto sticky-header-wrapper">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!--  <div-->
  <!--    class="relative flex flex-0 items-center justify-start w-full h-14 px-[1.5rem] md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"-->
  <!--  >-->
  <!--    <span class="font-medium text-secondary">Optimum Grading &copy; {{ currentYear }}</span>-->
  <!--  </div>-->
  <app-impersonation-banner></app-impersonation-banner>
  <div class="coach-banner-stack">
    <og-subscription-banner></og-subscription-banner>
    <og-email-reports-banner></og-email-reports-banner>
  </div>
</div>
